import { usePageTitle } from '@/composables';

export default async to => {
  usePageTitle().setTitle(to.meta.title);
};
